import { useMemo } from 'react'
import { MAP_THEME } from 'editor'
import { GRID_SIZE } from 'features/floorMap/floorMap.config'

const tokenColor = (styles: CSSStyleDeclaration, name: string, alpha = 1) =>
	`rgba(${styles.getPropertyValue(`--${name}`).trim().split(/\s+/).join(', ')}, ${alpha})`

export const useFloorMapTheme = () =>
	useMemo(() => {
		const styles = getComputedStyle(document.documentElement)

		return {
			...MAP_THEME,
			gridSize: GRID_SIZE,
			gridColor: tokenColor(styles, 'border', 0.6),
			stroke: tokenColor(styles, 'foreground', 0.3),
			textColor: tokenColor(styles, 'foreground'),
			selectionColor: tokenColor(styles, 'primary'),
			selectionRingColor: tokenColor(styles, 'primary', 0.5)
		}
	}, [])
